import { ElxFilter, FilterProps } from '@elixir/components';
import React from 'react';

export const EHFilter = (props: FilterProps): JSX.Element => {
  return <ElxFilter {...props} />;
};
